module.exports = __webpack_public_path__ + "f34e19c343b0f1cbb109d0e33bf6960c.jpg";